import React from 'react'

import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'

import './MissingPhoneWarning.scss'

const MissingPhoneWarning = ({ user }) => {
  const missingPhone = isEmpty(user.Phone)
  const missingCell = isEmpty(user.CellPhone)
  return (
    missingPhone &&
    missingCell && (
      <div className="missing-phone-warning-comp">
        <span>* &nbsp;</span>
        <span>
          We recommend using at least one <strong>phone number</strong> to guarantee visit updates and communication.
        </span>
      </div>
    )
  )
}
MissingPhoneWarning.propTypes = {
  user: PropTypes.object.isRequired,
}
export default MissingPhoneWarning
